import type { JSX } from "react";

const paths = {
  cage: <path d="M4 3v18M9 3v18M15 3v18M20 3v18M2 8h20M2 16h20" />,
  fist: (
    <path d="M7 11V7a2 2 0 1 1 4 0v4M11 9V6a2 2 0 1 1 4 0v5M15 10V8a2 2 0 1 1 4 0v6a6 6 0 0 1-6 6h-2a6 6 0 0 1-6-6v-2a2 2 0 1 1 4 0" />
  ),
  clock: <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 7v5l3 2" />,
  alert: (
    <path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
  ),
  info: <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 16v-4M12 8h.01" />,
  trophy: (
    <path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4ZM7 6H4a3 3 0 0 0 3 5M17 6h3a3 3 0 0 1-3 5" />
  ),
  exit: <path d="M10 17l5-5-5-5M15 12H3M21 3v18" />,
  mouse: <path d="M12 2a6 6 0 0 0-6 6v8a6 6 0 0 0 12 0V8a6 6 0 0 0-6-6ZM12 2v6" />,
  lock: <path d="M6 11h12v10H6V11ZM8 11V8a4 4 0 1 1 8 0v3M12 15v2" />,
  users: (
    <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM2 21v-1a6 6 0 0 1 6-6h2a6 6 0 0 1 6 6v1M16 3.5a4 4 0 0 1 0 7M18 14a5 5 0 0 1 4 5v2" />
  ),
  bot: <path d="M5 9h14v11H5V9ZM12 4v5M9 14h.01M15 14h.01M9 17h6M2 13v3M22 13v3M10 4h4" />,
  refresh: <path d="M20 11a8 8 0 0 0-14.9-3M4 4v4h4M4 13a8 8 0 0 0 14.9 3M20 20v-4h-4" />,
  play: <path d="M7 4v16l13-8L7 4Z" />,
  plus: <path d="M12 5v14M5 12h14" />,
  minus: <path d="M5 12h14" />,
  volume: <path d="M4 9v6h4l5 4V5L8 9H4ZM16 9a4 4 0 0 1 0 6M18.5 6.5a8 8 0 0 1 0 11" />,
} satisfies Record<string, JSX.Element>;

export type IconName = keyof typeof paths;

export function Icon({ name, label }: { name: IconName; label?: string }) {
  return (
    <svg
      className="icon"
      viewBox="0 0 24 24"
      aria-hidden={label ? undefined : true}
      role={label ? "img" : undefined}
      aria-label={label}
    >
      {paths[name]}
    </svg>
  );
}
